<template>
  <div class="whiteBg">
    <div class="tab-page container downloads">
      <div class="text">
        <div class="mt-8"></div>
        <v-row justify="center" align="center">
          <v-col class="text-center pt-16">
            <v-row
              style="
                display: block;
                font-style: normal;
                font-weight: 700;
                font-size: 32px;
                line-height: 48px;
                text-align: center;
                color: #212121;
              ">
              슈퍼멤버스 도입 문의
            </v-row>
            <v-row
              class="body--matching mt-3"
              style="
                display: block;
                font-style: normal;
                font-weight: 700;
                font-size: 15px;
                line-height: 27px;
                /* identical to box height, or 180% */

                text-align: center;

                color: #484848;
              ">
              딱 맞는 블로그 마케팅을 제안받아 보세요.
            </v-row>
            <v-row class="mb-16 mt-6">
              <v-col class="whiteBg lead-form">
                <LeadForm v-model="formData" @handleFormValid="handleFormValid" />
                <div class="d-flex justify-end">
                  <button
                    class="submit-button white-two--text rounded-lg mt-6"
                    :style="{ opacity: !isFormValid ? '0.2' : '1', maxWidth: '327px' }"
                    flat
                    :disabled="!isFormValid"
                    @click="submitForm">
                    무료 상담하기
                  </button>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import LeadForm from '@/components/company/lead/LeadForm.vue';

export default {
  name: 'Downloads',
  components: {
    LeadForm,
  },
  mounted() {
    let pipedriveScript = document.createElement('script');
    pipedriveScript.setAttribute('src', 'https://webforms.pipedrive.com/f/loader');
    document.head.appendChild(pipedriveScript);
  },
  data() {
    return {
      formData: {
        type: 'STORE',
        name: '',
        x: '',
        y: '',
        contact: '',
        isPrivacyAgreed: false,
        isMarketingAgreed: false,
        roadAddress: '',
      },
      showConsultDialog: false,
      isFormValid: false,
    };
  },
  methods: {
    handleFormValid(isValid) {
      this.isFormValid = isValid;
    },
    async submitForm() {
      try {
        const response = await axios
          .post('/marketing-lead', {
            companyName: this.formData.name,
            adCategory: this.formData.type,
            contact: this.formData.contact,
            agreeToMarketing: this.formData.isMarketingAgreed,
            x: this.formData.x,
            y: this.formData.y,
            address: this.formData.roadAddress,
          })
          .then(res => {
            return res.data;
          });

        if (response.data) {
          const leadId = response.data.id;
          const companyName = this.formData.name;
          const x = this.formData.x;
          const y = this.formData.y;

          let uri = '/leadcomplete';
          const utm =
            'leadsource=landing_bottom&utm_source=organic-internal&utm_medium=link&utm_campaign=sm_company&utm_term=mkt-lead&utm_content=250414';

          if (leadId) {
            uri += `?leadId=${leadId}&type=${this.formData.type}&companyName=${companyName}`;
            if (x && y) {
              uri += `&x=${x}&y=${y}&${utm}`;
            } else {
              uri += `&${utm}`;
            }
          } else {
            uri += `?${utm}`;
          }

          this.$router.push(uri);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.downloads {
  display: flex;
  flex-direction: row;
  align-content: center;
  .text {
    text-align: center;
    margin: 120px auto;
    width: 742px;

    .eyebrow {
      color: #757575;
      margin-bottom: 4px;
      margin-left: 1px;
    }
    h2 {
      color: #212121;
    }
    p {
      color: #484848;
      line-height: 1.8;
    }
    button {
      background-color: #ea2a3a;
      height: 48px;
      border-radius: 24px;
      font-size: 14px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
    }
  }
}

@media (max-width: 960px) {
  .downloads {
    flex-direction: column-reverse;
    justify-content: flex-end;
    align-content: center;
    overflow: hidden;
    margin: 0 auto 0;
    .row-image {
      width: 375px;
      height: auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .text {
      width: 375px;
      margin: 112px auto;
      padding-top: 0;
      .eyebrow {
        margin-bottom: 6px;
      }
      h2 {
      }
      p {
        color: #484848;
        line-height: 1.94;
      }
    }
    button {
      background-color: #fff;
      height: 48px;
      border-radius: 24px;
      font-size: 14px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
    }
  }
}

.signup {
  width: 220px;
  height: 48px;
  color: #fff;
  border-radius: 24px;
  box-shadow: 0 12px 24px 0 rgba(75, 75, 75, 0.1);
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
}

.whiteBg {
  background-color: #fbfbfb;
}

.pipedrive-request {
  background-color: white;
  border-radius: 24px;
  width: 200px;
  filter: drop-shadow(0px 16px 32px rgba(0, 0, 0, 0.1));
}

.lead-form {
  display: block;
  text-align: start;
  background-color: white;
  padding: 24px;
  border-radius: 24px;
  box-shadow: 0px 16px 32px 0px rgba(0, 0, 0, 0.1);
}
.submit-button {
  width: 100%;
  height: 44px;
  border-radius: 4px;
  background-color: var(--primary-light-color);
  color: white;
}
</style>
